import React from 'react';
import SwiperWithButtons from './SwiperWithButtons';

const styles = {
  slideContainer: {
    padding: '0 10px',
    width: '100%'
  },
  slide: {
    color: '#fff',
  },
  slide1: {
    padding: '.2em'
  },
};

const _useCss = false

const SwiperGroup = (props) => {

  const { content, useHorizontal } = props ?? {}

  const swipeableContent = () => {
    if (_useCss) {
      return <div className={useHorizontal ? "horz-container" : 'horz-container-ns'} >
        {content}
      </div>
    } else {
      return <SwiperWithButtons
        swipeItems={<div style={Object.assign({}, styles.slideContainer)}>
          <div style={Object.assign({}, styles.slide, styles.slide1)}>
            {content}
          </div>
        </div>}
      />
    }
  }

  return swipeableContent()

}

export default SwiperGroup